import { defineMessages, useIntl } from 'react-intl';
import { ContentCell } from '@cbhq/cds-web/cells';
import { CoinbaseProfileMenuResource } from '@cbhq/identity-api-hooks/profile-menu/types';

import { ResourceMedia } from './ResourceMedia';

const messages = defineMessages({
  legalEntity: {
    id: 'ResourceHeader.legalEntity',
    defaultMessage: 'Entity',
    description: 'Description for the legal entity resource type',
  },
  user: {
    id: 'ResourceHeader.user',
    defaultMessage: 'Personal',
    description: 'Description for the personal resource type',
  },
});

type ResourceHeaderProps = { selectedResource: CoinbaseProfileMenuResource | undefined };

export function ResourceHeader({ selectedResource }: ResourceHeaderProps) {
  const { formatMessage } = useIntl();

  if (!selectedResource) {
    return null;
  }

  const description =
    selectedResource.resourceType === 'legal_entity'
      ? formatMessage(messages.legalEntity)
      : formatMessage(messages.user);

  return (
    <ContentCell
      title={selectedResource.name}
      media={<ResourceMedia resource={selectedResource} />}
      description={description}
    />
  );
}
